export default __webpack_public_path__ + "static/media/program.25bd592f.png";